// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".f10fa343a2a129038cb42a67d7d90ff5.js";
};